import axios from "./axios-setup";
import { AxiosRequestConfig, AxiosError, AxiosResponse } from "axios";

export class Http {
  static lastCalls = new Map<string, number>();

  static setBaseUrl(url: string) {
    axios.defaults.baseURL = url;
  }

  static async get(url: string, params?: any): Promise<any> {
    try {
      const res = await axios.get(url, { params });
      return res;
    } catch (e) {
      const error = e as AxiosError;
      throw error.response;
    }
  }

  static async getOne(url: string, params?: any): Promise<any> {
    try {
      const res = await axios.get(params ? `${url}/${params}` : url);
      return res;
    } catch (e) {
      const error = e as AxiosError;
      throw error.response;
    }
  }

  static async post(url: string, _data?: any, option?: any): Promise<any> {
    try {
      const { data, status } = await axios.post(url, _data, option);
      return { data, status };
    } catch (e) {
      const error = e as AxiosError;
      throw error.response;
    }
  }

  static async put(url: string, params: AxiosRequestConfig<any>): Promise<any> {
    try {
      const res = await axios.put(url, params, {
        headers: {
          "Content-Type": "application/ld+json",
        },
      });
      return res;
    } catch (e) {
      const error = e as AxiosError;
      throw error.response;
    }
  }

  static async patch(url: string, params: any): Promise<any> {
    const { id, ...rest } = params;
    try {
      const res = await axios.patch(`${url}/${id}`, rest, {
        headers: {
          "Content-Type": "application/merge-patch+json",
        },
      });
      return res;
    } catch (e) {
      const error = e as AxiosError;
      throw error.response;
    }
  }

  static async patchCustom(url: string, params: any): Promise<any> {
    try {
      const res = await axios.patch(url, params, {
        headers: {
          "Content-Type": "application/merge-patch+json",
        },
      });
      return res;
    } catch (e) {
      const error = e as AxiosError;
      throw error.response;
    }
  }

  static async delete(url: string, id?: any): Promise<any> {
    try {
      const data = await axios.delete(id ? `${url}/${id}` : url);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return error.response;
    }
  }

  static async getWithTyped(
    url: string,
    params?: any
  ): Promise<AxiosResponse<any>> {
    try {
      const res = await axios.get<any>(url, { params });
      return res;
    } catch (e) {
      const error = e as AxiosError;
      throw error.response;
    }
  }

  static async getFile(url: string, params?: any): Promise<any> {
    try {
      const token = localStorage.getItem("access_token");
      const res = await axios.get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      });
      return res;
    } catch (e) {
      const error = e as AxiosError;
      throw error.response;
    }
  }
}
